module.exports = __webpack_public_path__ + "img/vuoisaperne-image.cdfea2a5.png";